
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
this.list = [ {
label: '中文名称',
value: this.$route.params.PT_NAME
}, {
label: '证书类别',
value: this.$route.params.PT_CLASS
}, {
label: '强制级别',
value: this.$route.params.PT_LEVEL
}, {
label: '许可类别说明',
value: this.$route.params.PT_Remark
}]
console.log(this.$route.params)
}
}



// WEBPACK FOOTER //
// ./src/components/P_PermitTypeDetail.vue